import { composeIO } from 'react-compose-io'
import { linhaTabelaCicloIO } from './LinhaTabelaCiclo.IO'
import { LinhaTabelaCicloView } from './LinhaTabelaCiclo.View'

export const LinhaTabelaCiclo = composeIO(LinhaTabelaCicloView, linhaTabelaCicloIO)
